var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-style")))]),
      _c(
        "w-scroll-view",
        [
          _c(
            "w-scroll-view",
            {
              staticClass: "preview-content",
              attrs: { tag: "w-card-content" },
            },
            [
              _c("div", { style: _vm.toEditStyle.getStyle() }, [
                _c("img", {
                  style: _vm.toEditStyle.getImgStyle(),
                  attrs: {
                    src: require("@/assets/img/logo_r.png"),
                    alt: "Preview image",
                  },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "seperator" }),
          _c("w-tabs", {
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
          _c(
            "w-card-content",
            [
              _vm.tab == 0
                ? _c(
                    "div",
                    [
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "last cf",
                          attrs: { label: _vm.$ct("positioning") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleColor styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _c("div", [
                                _vm._v(" " + _vm._s(_vm.generalText) + " "),
                              ]),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("width-mm"),
                                    },
                                    model: {
                                      value: _vm.toEditStyle.Width,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.toEditStyle, "Width", $$v)
                                      },
                                      expression: "toEditStyle.Width",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("height-mm"),
                                    },
                                    model: {
                                      value: _vm.toEditStyle.Height,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.toEditStyle, "Height", $$v)
                                      },
                                      expression: "toEditStyle.Height",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("horizontal-alignment"),
                                      items: _vm.horizontalAlignItems,
                                    },
                                    model: {
                                      value: _vm.toEditStyle.HorizontalAlign,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "HorizontalAlign",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.HorizontalAlign",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("vertical-alignment"),
                                      items: _vm.verticalAlignItems,
                                    },
                                    model: {
                                      value: _vm.toEditStyle.VerticalAlign,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "VerticalAlign",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.VerticalAlign",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("image-fit-label"),
                                      items: _vm.fitItems,
                                    },
                                    model: {
                                      value: _vm.toEditStyle.Fit,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.toEditStyle, "Fit", $$v)
                                      },
                                      expression: "toEditStyle.Fit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "last cf",
                          attrs: { label: _vm.$ct("colors") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleColor styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _c(
                                "div",
                                {
                                  style: {
                                    backgroundColor:
                                      _vm.toEditStyle.BackgroundColor || "#fff",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$ct("backgroundColor")) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("app-color-picker", {
                                    attrs: {
                                      color: _vm.toEditStyle.BackgroundColor,
                                      label: _vm.$ct("backgroundColor"),
                                      fancy: "",
                                      up: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.BackgroundColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "BackgroundColor",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.BackgroundColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tab == 1
                ? _c(
                    "div",
                    [
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("margins") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.toEditStyle.MarginTop || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginRight || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginBottom || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginLeft || 0) +
                                  "mm "
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("margin.top"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginTop,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginTop",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginTop",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("margin.right"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginRight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginRight",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginRight",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("margin.bottom"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginBottom,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginBottom",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginBottom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("margin.left"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginLeft,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginLeft",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginLeft",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("paddings") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.toEditStyle.PaddingTop || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingRight || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingBottom || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingLeft || 0) +
                                  "mm "
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("padding.top"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingTop,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingTop",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingTop",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("padding.right"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingRight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingRight",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingRight",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("padding.bottom"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingBottom,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingBottom",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingBottom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 0,
                                      decimals: 0,
                                      label: _vm.$ct("padding.left"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingLeft,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingLeft",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingLeft",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tab == 2
                ? _c(
                    "div",
                    [
                      _c("app-style-editor-border", {
                        staticClass: "w-toggle-group last cf",
                        attrs: { "to-edit-style": _vm.toEditStyle },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("w-row"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.closeClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.updateValue()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }